<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Company') : $t('New Company')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-tabs v-model="tab" background-color="gray" dark right v-else>
            <v-tab key="data">{{ $t("data") }}</v-tab>
            <v-tab key="users">{{ $t("Assigned users") }}</v-tab>
            <v-tab key="door_types">{{ $t("rights") }}</v-tab>
            <v-tab key="number_ranges">{{ $t("number_ranges") }}</v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item key="data">
                <v-card>
                  <v-form
                    ref="form"
                    autocomplete="new-password"
                    lazy-validation
                    @submit.prevent="saveItem"
                  >
                    <v-text-field
                      v-model="formValues.name"
                      :label="$t('Name')"
                      autocomplete="new-password"
                      v-validate="'required'"
                      required
                      data-vv-name="name"
                      :error-messages="errors.collect('name')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.street"
                      :label="$t('Street')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="street"
                      :error-messages="errors.collect('street')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.city"
                      :label="$t('City')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="city"
                      :error-messages="errors.collect('city')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.zip"
                      :label="$t('Zip')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="zip"
                      :error-messages="errors.collect('zip')"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.email"
                      :label="$t('Email')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="email"
                      :error-messages="errors.collect('email')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.website"
                      :label="$t('Website')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="website"
                      :error-messages="errors.collect('website')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.phone"
                      :label="$t('Phone')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="phone"
                      :error-messages="errors.collect('phone')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.tax_id"
                      :label="$t('tax_id')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="tax_id"
                      :error-messages="errors.collect('tax_id')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.personal_tax_id"
                      :label="$t('personal_tax_id')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="personal_tax_id"
                      :error-messages="errors.collect('personal_tax_id')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.prefix"
                      :label="$t('Prefix')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="prefix"
                      :error-messages="errors.collect('prefix')"
                    ></v-text-field>
                    <v-card color="#eeeeee" dark>
                      <v-card-title>
                        Prefix Konfiguration
                      </v-card-title>
                      <v-card-text>
                        <p>
                          <small
                            >%Y -> Jahr 4 Stellen<br />
                            %y -> Jahr 2 Stellen<br />
                            %M -> Monat<br />
                            %D -> Tag<br />
                            %W -> Kalenderwoche<br />
                            %N5 -> Fortlaufende Nummer, wobei die Zahl die
                            Anzahl der Ziffern angibt</small
                          >
                        </p>
                      </v-card-text>
                    </v-card>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formValues.exit_at"
                          :label="$t('exit_at')"
                          prepend-icon="mdi-calendar"
                          clearable
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formValues.exit_at"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <v-checkbox
                      v-model="formValues.active"
                      :label="$t('activated')"
                      v-validate=""
                      data-vv-name="active"
                      :error-messages="errors.collect('active')"
                    ></v-checkbox>
                    <v-card color="grey lighten-2">
                      <v-card-title>
                        {{ $t("locked_details") }}
                      </v-card-title>
                      <v-card-text class="pa-2">
                        <v-checkbox
                          v-model="formValues.locked"
                          :label="$t('locked')"
                          v-validate=""
                          data-vv-name="locked"
                          :error-messages="errors.collect('locked')"
                        ></v-checkbox>
                        <v-text-field
                          v-if="formValues.locked"
                          v-model="formValues.locked_info"
                          :label="$t('locked_info')"
                          autocomplete="new-password"
                          v-validate=""
                          data-vv-name="locked_info"
                          :error-messages="errors.collect('locked_info')"
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                    <v-text-field
                      v-model="formValues.kobra_customer_id"
                      :label="$t('kobra_customer_id')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="kobra_customer_id"
                      :error-messages="errors.collect('kobra_customer_id')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.csi_number"
                      :label="$t('csi_number')"
                      autocomplete="new-password"
                      v-validate=""
                      data-vv-name="csi_number"
                      :error-messages="errors.collect('csi_number')"
                    ></v-text-field>
                    <v-card color="grey lighten-2">
                      <v-card-title>
                        {{ $t("mounting_details") }}
                      </v-card-title>
                      <v-card-text class="pa-2">
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="formValues.mounting_person_name"
                              :label="$t('mounting_person_name')"
                              autocomplete="new-password"
                              v-validate=""
                              data-vv-name="mounting_person_name"
                              :error-messages="
                                errors.collect('mounting_person_name')
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="formValues.mounting_person_phone"
                              :label="$t('mounting_person_phone')"
                              autocomplete="new-password"
                              v-validate=""
                              data-vv-name="mounting_person_phone"
                              :error-messages="
                                errors.collect('mounting_person_phone')
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="formValues.processing_person_name"
                              :label="$t('processing_person_name')"
                              autocomplete="new-password"
                              v-validate=""
                              data-vv-name="processing_person_name"
                              :error-messages="
                                errors.collect('processing_person_name')
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="formValues.processing_person_phone"
                              :label="$t('processing_person_phone')"
                              autocomplete="new-password"
                              v-validate=""
                              data-vv-name="processing_person_phone"
                              :error-messages="
                                errors.collect('processing_person_phone')
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <v-card-actions class="pl-0">
                      <v-btn
                        color="primary"
                        class="mr-4"
                        @click="$router.push({ name: 'company.index' })"
                      >
                        {{ $t("back") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" class="mr-4" @click="saveItem">
                        {{ $t("save") }}
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-tab-item>
              <v-tab-item key="users">
                <v-card>
                  <div v-if="$route.params.id">
                    <h4 class="font-weight-light mb-2 mt-8">
                      {{ $t("Assigned users") }}
                    </h4>
                    <v-data-table
                      :headers="headers"
                      :items="formValues.users"
                      :loading="loading"
                      :multi-sort="true"
                      class="elevation-1"
                      :footer-props="{
                        'items-per-page-options': [10, 15, 50, -1]
                      }"
                    >
                    </v-data-table>
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item key="door_types">
                <v-card :loading="copyFromOtherLoading">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="mr-4"
                      @click="openCopyFromOther"
                    >
                      {{ $t("copy from other") }}
                    </v-btn>
                    <v-dialog
                      v-model="copyFromOtherDialog"
                      scrollable
                      persistent
                      :overlay="false"
                      max-width="500"
                      transition="dialog-transition"
                    >
                      <v-card>
                        <v-card-text>
                          <v-autocomplete
                            v-model="copyFromOtherCompany"
                            :items="companies"
                            label="Companies"
                            item-text="name"
                            item-value="id"
                          ></v-autocomplete>
                        </v-card-text>
                        <v-card-actions class="pl-0">
                          <v-btn
                            color="primary"
                            class="mr-4"
                            @click="closeCopyFromOther"
                          >
                            {{ $t("back") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="mr-4"
                            @click="copyFromOther"
                          >
                            {{ $t("copy") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-title>
                  <table class="rights">
                    <thead>
                      <th>Name</th>
                      <th v-for="country in countries" :key="country.id">
                        {{ country.name }} [{{ country.country_code }}]
                      </th>
                    </thead>
                    <tbody>
                      <div
                        style="display: contents"
                        v-for="(type_category,
                        categoryIndex) in production_authorizations"
                        :key="categoryIndex"
                      >
                        <tr class="category">
                          <td>
                            <h4>{{ type_category.name }}</h4>
                          </td>
                          <td v-for="country in countries" :key="country.id">
                            <v-checkbox
                              success
                              v-model="
                                type_category.country[country.country_code]
                              "
                              @click="
                                changeTypeCategoryRigths(
                                  type_category,
                                  country.country_code
                                )
                              "
                            >
                              <template v-slot:label>
                                <span
                                  v-if="
                                    type_category.country[country.country_code]
                                  "
                                  >Produtkion Erlaubt</span
                                >
                                <span v-else>Produktion nicht erlaubt</span>
                              </template>
                            </v-checkbox>
                          </td>
                        </tr>
                        <tr
                          v-for="(door_type,
                          door_type_key) in type_category.door_types"
                          :key="door_type_key"
                          class="doortype"
                        >
                          <td>
                            <a
                              :href="'/doortype/' + door_type.id"
                              target="_blank"
                              :title="door_type.name"
                              >{{ door_type.code }}</a
                            >
                            <div class="mt-1" v-if="door_type.numberranges">
                              <v-chip
                                small
                                class="white--text mr-1 mb-1"
                                color="grey darken-3"
                                v-for="(numberrange,
                                index) in door_type.numberranges"
                                :key="index"
                                >{{ numberrange }}</v-chip
                              >
                            </div>
                          </td>
                          <td v-for="country in countries" :key="country.id">
                            <v-row>
                              <v-col>
                                <v-select
                                  v-model="
                                    door_type.country[country.country_code]
                                  "
                                  :items="selectItems"
                                  label="Produktion"
                                  @change="
                                    changeDoorTypeRights(
                                      door_type,
                                      country.country_code,
                                      type_category
                                    )
                                  "
                                ></v-select>
                              </v-col>
                              <v-col>
                                <div
                                  v-if="
                                    ((type_category.country[
                                      country.country_code
                                    ] &&
                                      door_type.country[
                                        country.country_code
                                      ]) != false ||
                                      door_type.country[
                                        country.country_code
                                      ]) &&
                                      door_type.label_per_customer[
                                        country.country_code
                                      ].label_required
                                  "
                                >
                                  <v-select
                                    v-if="
                                      !door_type.label_per_customer[
                                        country.country_code
                                      ].generic
                                    "
                                    v-model="
                                      door_type.label_per_customer[
                                        country.country_code
                                      ].label_type_id
                                    "
                                    :items="
                                      computedLabelTypes.filter(item => {
                                        return true;
                                      })
                                    "
                                    label="Plakette*"
                                    item-text="name"
                                    item-value="id"
                                    v-validate="'required'"
                                    :error-messages="
                                      errors.collect(
                                        categoryIndex +
                                          '.door_types.' +
                                          door_type_key +
                                          '.label_per_customer.' +
                                          country.country_code +
                                          '.label_type_id'
                                      )
                                    "
                                  ></v-select>
                                  <v-text-field
                                    v-else
                                    disabled
                                    placeholder="Keine Plakette Notwendig"
                                  >
                                  </v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </div>
                    </tbody>
                  </table>
                  <v-card-actions class="pl-0">
                    <v-btn
                      color="primary"
                      class="mr-4"
                      @click="$router.push({ name: 'company.index' })"
                    >
                      {{ $t("back") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="mr-4"
                      @click="saveProcutionAuhtorizations"
                    >
                      {{ $t("save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item key="number_ranges">
                <v-card>
                  <div v-if="$route.params.id">
                    <h4 class="font-weight-light mb-2 mt-8">
                      {{ $t("number_ranges") }}
                    </h4>
                    <v-data-table
                      :headers="number_range_headers"
                      :items="formValues.number_ranges"
                      :loading="loading"
                      :multi-sort="true"
                      class="elevation-1"
                      :footer-props="{
                        'items-per-page-options': [10, 15, 50, -1]
                      }"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          @click="openLastNoDialog(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-dialog
                      v-model="lastNoDialog"
                      scrollable
                      persistent
                      :overlay="false"
                      max-width="500"
                      transition="dialog-transition"
                    >
                      <v-card>
                        <v-card-text>
                          <v-text-field
                            v-model="last_no"
                            label="Last No"
                            type="number"
                            v-validate=""
                            data-vv-name="last_no"
                            :error-messages="errors.collect('last_no')"
                          ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            color="primary"
                            class="mr-4"
                            @click="closeLastNoDialog"
                          >
                            {{ $t("back") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="mr-4"
                            @click="saveLastNo"
                          >
                            {{ $t("save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  saveProductionAuthorizations,
  fetchLabeltypes,
  fetchItems,
  saveLastNo
} from "../shared/services";
import { fetchItems as fetchCountries } from "../../countries/shared/services";
export default {
  name: "app-company-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: "",
        locked: false,
        locked_info: ""
      },
      tab: 0,
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" }
      ],
      production_authorizations: [],
      labeltypes: [],
      countries: [],
      selectItems: [
        {
          text: "Nein",
          value: 0
        },
        {
          text: "Ja",
          value: 1
        },
        {
          text: "Wie Kategorie",
          value: null
        }
      ],
      copyFromOtherDialog: false,
      companies: [],
      copyFromOtherCompany: null,
      copyFromOtherLoading: false,
      number_range_headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Last No", value: "pivot.last_no" },
        { text: "", value: "action", sortable: false }
      ],
      lastNoDialog: false,
      last_no: null,
      editNumberRange: null
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
        this.production_authorizations = res.authorizations;
      });
      fetchCountries().then(res => {
        this.countries = res.data;
      });
      fetchLabeltypes().then(res => {
        this.labeltypes = res.data;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    computedLabelTypes() {
      return this.labeltypes.filter(item => {
        return item.company_id == this.formValues.id;
      });
    }
  },
  methods: {
    async saveItem() {
      if (!this.formValues.locked) {
        this.formValues.locked_info = "";
      }
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "company.index" });
      }
    },
    async saveProcutionAuhtorizations() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveProductionAuthorizations(
        this.$route.params.id,
        this.production_authorizations,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.errors.clear();
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
          this.production_authorizations = res.authorizations;
        });
        // this.$router.push({ name: "company.index" });
      }
    },
    openCopyFromOther() {
      this.copyFromOtherDialog = true;
      this.copyFromOtherLoading = true;
      fetchItems().then(res => {
        this.companies = res.data;
        this.copyFromOtherLoading = false;
      });
    },
    closeCopyFromOther() {
      this.copyFromOtherDialog = false;
      this.copyFromOtherCompany = null;
    },
    copyFromOther() {
      this.copyFromOtherLoading = true;
      fetchItem(this.copyFromOtherCompany).then(res => {
        this.authorizations = res.authorizations.forEach(category => {
          category.door_types.forEach(door_type => {
            for (const [key, value] of Object.entries(
              door_type.label_per_customer
            )) {
              value.label_type_id = null;
            }
          });
        });
        this.production_authorizations = res.authorizations;
        this.closeCopyFromOther();
        this.copyFromOtherLoading = false;
      });
    },
    openLastNoDialog(item) {
      this.lastNoDialog = true;
      this.editNumberRange = item;
      this.last_no = item.pivot.last_no;
    },
    changeTypeCategoryRigths(type_category, country) {
      type_category.door_types.forEach(function(value, i) {
        value.country[country].required = type_category.country[country];
      });
    },
    changeDoorTypeRights(doortype, country, type_category) {
      if (doortype.country[country] == 0) {
        doortype.label_per_customer[country].label_type_id = null;
        doortype.label_per_customer[country].required = false;
      } else if (doortype.country[country] == 1) {
        doortype.label_per_customer[country].label_type_id = null;
        doortype.label_per_customer[country].required = true;
      } else if (doortype.country[country] == null) {
        //check category
        if (type_category.country[country] == true) {
          doortype.label_per_customer[country].label_type_id = null;
          doortype.label_per_customer[country].required = true;
        } else {
          doortype.label_per_customer[country].label_type_id = null;
          doortype.label_per_customer[country].required = false;
        }
      }
    },
    async closeLastNoDialog() {
      await fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
      this.lastNoDialog = false;
      this.last_no = null;
    },
    async saveLastNo() {
      let resp = await saveLastNo(
        this.$route.params.id,
        this.editNumberRange.id,
        { last_no: this.last_no },
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.closeLastNoDialog();
      }
    }
  },
  watch: {
    "formValues.locked"(val) {
      if (!val) {
        this.formValues.locked_info = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
table.rights {
  width: 100%;
  min-width: 800px;
}

table.rights td {
  padding: 5px;
}

table.rights tbody tr.category {
  background: #424242 !important;
  color: #fff;
}
table.rights tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

table.rights tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
